import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
    selector: 'app-indetail-datewise-rpt',
    templateUrl: './indetail-datewise-rpt.component.html',
    styleUrl: './indetail-datewise-rpt.component.scss'
})
export class IndetailDatewiseRptComponent {
    [x: string]: any;
    rep_name: any;
    off_rep_name: any;
    issue_date: any;
    inDetailsRegReport: any;
    issuenamewithdate: any;
    inDetailsRegReport1: any;
    gstadvtamt: number;
    remaingtotal: number;
    totalpendingadvtamt: number;
    totalbefore_gst: number;
    total_pending: number;
    inDetailsRegReportrep: any;
    show: boolean;
    start_date = '';
    end_date = '';
    newissuedatepp: any;
    issue_cat: any;
    today1: any;
    inDetailsRegReportdatewise: any;
    advtamt: any;
    totaldisc_total: any;
    totaladvtamt: any;
    totalbeforegst_amt: any;
    totalgst: any;
    netadvtamt: any;
    jamatotal: any;
    issueCopies: any;

    constructor(
        private dialogref: MatDialogRef<IndetailDatewiseRptComponent>,
        private datePipe: DatePipe,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: DigisubservicesService
    ) {

    }

    ngOnInit(): void {
       this.type = this.data['type'];
      this.start_date = this.data['start_date'];
      this.end_date = this.data['end_date'];
      this.rep_name = this.data['rep_name'];
      this.off_rep_name = this.data['off_rep_name'];
      this.newissuedatepp = this.data['newissuedatepp'];
    
      this.issue_cat = this.data['issue_cat'] === undefined ? "ALL" : this.data['issue_cat'];
    
      // Extract only the date part (before first comma)
      const issueDateRaw = this.data['issueDates'];
      if (Array.isArray(issueDateRaw) && issueDateRaw.length > 0) {
        this.issue_date = issueDateRaw[0].split(',')[0];
      } else {
        this.issue_date = "ALL";
      }
    
      console.log("Final Payload Data:", {
        representativeId: this.rep_name,
        startDate: this.start_date,
        endDate: this.end_date,
        officeRepresentativeId: this.off_rep_name,
        issueNameId: this.issue_cat,
        issueSellerDate: this.issue_date
      });
        this.getReportData()
    }

    getReportData() {

        const req1: any = {

            "start_date": this.start_date,
            "end_date": this.end_date,
            "rep_name": this.rep_name,
            "off_rep_name": this.off_rep_name,
            "issuename": this.issue_cat,
            "issue_date": this.issue_date
        }
        this.service.getissueRegReportInDetailsdatewise(req1).subscribe((data) => {
            this.inDetailsRegReportdatewise = data;

            this.issue_amt = 0;
            this.netissueamt = 0;
            this.gstadvtamt = 0;
            this.totaladvtamt = 0;
            this.totalgst = 0;
            this.remaingtotal = 0;
            this.totalpendingadvtamt = 0;
            this.jamatotal = 0;
            this.totaldisc_total = 0;
            this.totalbefore_gst = 0;
            this.total_pending = 0
            this.issueCopies = 0;
            for (let data2 of this.inDetailsRegReportdatewise) {
                debugger
                for (let data1 of data2.issue_data) {
                    this.issue_amt += parseFloat(data1.issue_amt) || 0;
                    this.netissueamt += parseFloat(data1.net_amount) || 0;
                    this.totaladvtamt += parseFloat(data1.net_amount) || 0;
                    // data1.remaingamt = Number(data1.amount) - Number(data1.part_pymt_amt)
                    this.remaingtotal += parseFloat(data1.total_pending) || 0;
                    this.jamatotal += parseFloat(data1.pymt_rcv_amt) || 0;
                    this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
                    this.totalbefore_gst += parseFloat(data1.beforegst_amt) || 0;
                    this.totalpendingadvtamt += parseFloat(data1.total_pending) || 0;
                    data1.totalgst = parseFloat(data1.sgst) + parseFloat(data1.cgst) + parseFloat(data1.igst)
                    this.totalgst += parseFloat(data1.totalgst) || 0;
                    this.total_pending += parseFloat(data1.remaining_amt) || 0;
                    this.issueCopies += parseFloat(data1.issue_copies)
                }


            }
        });
    }
    addFilters() {
        throw new Error('Method not implemented.');
    }
    getReportDatewise() {
        throw new Error('Method not implemented.');
    }
   print() {
      const originalTitle = document.title;
      document.title = '';
  
      const style = document.createElement('style');
      style.innerHTML = `
        @media print {
          @page {
            size: A4;
            margin: 0mm;
          }
          .print-header {
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .print-footer {
            position: fixed;
            bottom: 10px;
            left: 0;
            right: 0;
            text-align: center;
            font-size: 12px;
            color: gray;
          }
          .print-footer::after {
            content: "Page " counter(page) " of " counter(pages);
          }
          .no-print {
            display: none !important;
          }
        }
      `;
      document.head.appendChild(style);
  
      setTimeout(() => {
        const printTrigger = document.getElementById('print-button');
        if (printTrigger) (printTrigger as HTMLElement).click();
        document.title = originalTitle;
      }, 500);
    }
}
